import { primarySemiBoldFont, theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const root = css`
  padding: ${spacing.xs}px ${spacing.xl}px;
  ${primarySemiBoldFont};
  ${responsiveText.BODY.SM}
  text-align: center;

  a {
    color: inherit;

    &:hover {
      text-decoration: none;
    }
  }
`;

export const darkText = css`
  color: var(--neutral-black-base);
`;

export const lightText = css`
  color: var(--neutral-white-base);
`;
